import { useTranslation } from "react-i18next"
import { z } from "zod"

export function usePasswordRuleValidationSchema() {
  const { t } = useTranslation("app_server")
  const schema = z
    .object({
      password: z
        .string()
        .min(8)
        .regex(/[0-9]/)
        .regex(/[a-z]/)
        .regex(/[A-Z]/)
        .regex(/[$&+,:;=?@#|'<>.^*()%!-]/),
      confirmPassword: z.string(),
    })
    .superRefine(({ confirmPassword, password }, ctx) => {
      // eslint-disable-next-line security/detect-possible-timing-attacks
      if (password !== confirmPassword) {
        return ctx.addIssue({
          path: ["confirmPassword"],
          code: z.ZodIssueCode.custom,
          message: t("PasswordRule_Match"),
        })
      }
    })
  return { schema }
}
